import React, { useState } from 'react';
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Chip, TextField, FormControl, InputLabel,
  Select, MenuItem, Dialog, DialogTitle, DialogContent, Divider,
} from '@mui/material';
import { ventas, formatearMoneda, formatearFecha, nombreTienda } from '../data';

function Sales() {
  const [filtroTienda, setFiltroTienda] = useState('');
  const [detalle, setDetalle] = useState(null);

  const filtradas = ventas.filter(v => !filtroTienda || v.tienda === filtroTienda);

  return (
    <Box>
      <Typography variant="h4" fontWeight={700} mb={3}>Ventas</Typography>

      <Box display="flex" gap={2} mb={2} flexWrap="wrap">
        <FormControl size="small" sx={{ minWidth: 180 }}>
          <InputLabel>Tienda</InputLabel>
          <Select value={filtroTienda} label="Tienda" onChange={e => setFiltroTienda(e.target.value)}>
            <MenuItem value="">Todas</MenuItem>
            <MenuItem value="tizayuca">Bodega Central Tizayuca</MenuItem>
            <MenuItem value="tecamac">Tienda Física Tecámac</MenuItem>
            <MenuItem value="cdmx">Tienda Física CDMX</MenuItem>
            <MenuItem value="ecommerce">E-commerce</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Folio</TableCell>
              <TableCell>Fecha</TableCell>
              <TableCell>Tienda</TableCell>
              <TableCell>Tipo</TableCell>
              <TableCell>Pago</TableCell>
              <TableCell align="right">Total</TableCell>
              <TableCell align="center">Estado</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filtradas.map(v => (
              <TableRow key={v._id} hover sx={{ cursor: 'pointer' }} onClick={() => setDetalle(v)}>
                <TableCell sx={{ fontFamily: 'monospace', fontWeight: 600 }}>{v.folio}</TableCell>
                <TableCell>{formatearFecha(v.createdAt)}</TableCell>
                <TableCell><Chip label={nombreTienda(v.tienda)} size="small" variant="outlined" /></TableCell>
                <TableCell>{v.tipo_venta}</TableCell>
                <TableCell>{v.metodo_pago}</TableCell>
                <TableCell align="right" fontWeight={600}>{formatearMoneda(v.total)}</TableCell>
                <TableCell align="center">
                  <Chip
                    label={v.estado}
                    size="small"
                    color={v.estado === 'completada' ? 'success' : v.estado === 'cancelada' ? 'error' : 'warning'}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={!!detalle} onClose={() => setDetalle(null)} maxWidth="sm" fullWidth>
        <DialogTitle>Detalle de Venta {detalle?.folio}</DialogTitle>
        <DialogContent>
          {detalle && (
            <Box>
              <Box display="flex" gap={2} mb={2}>
                <Chip label={nombreTienda(detalle.tienda)} size="small" color="primary" variant="outlined" />
                <Chip label={detalle.metodo_pago} size="small" variant="outlined" />
                <Chip label={detalle.tipo_venta} size="small" variant="outlined" />
              </Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Fecha: {formatearFecha(detalle.createdAt)} | Vendedor: {detalle.vendedor}
              </Typography>
              <Divider sx={{ my: 1 }} />
              {detalle.productos.map((linea, i) => (
                <Box key={i} display="flex" justifyContent="space-between" py={0.5}>
                  <Box>
                    <Typography variant="body2" fontWeight={500}>{linea.producto.nombre}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      {linea.cantidad} x {formatearMoneda(linea.precio_unitario)}
                    </Typography>
                  </Box>
                  <Typography variant="body2" fontWeight={600}>{formatearMoneda(linea.subtotal)}</Typography>
                </Box>
              ))}
              <Divider sx={{ my: 1 }} />
              <Box display="flex" justifyContent="space-between">
                <Typography variant="h6">Total</Typography>
                <Typography variant="h6" fontWeight={700} color="primary">{formatearMoneda(detalle.total)}</Typography>
              </Box>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default Sales;
